import mapKnownValues from "@/utils/mapKnownValues";
import { NO_VALUE_DISPLAY } from "@/appConfig";

export default class Address {
  address1 = "";
  address2 = "";
  city = "";
  state = "";
  zip = "";

  constructor(params: Partial<Address> = {}) {
    mapKnownValues(this, params);
  }

  get formattedAddress() {
    const parts: string[] = [];
    if (this.address1) parts.push(this.address1);
    if (this.address2) parts.push(this.address2);
    if (this.city) parts.push(this.city);
    if (this.state) parts.push(this.state);
    if (this.zip) parts.push(this.zip);
    if (parts.length === 0) return NO_VALUE_DISPLAY;
    return parts.join(", ");
  }
}
